export default __webpack_public_path__ + "d186e65dd19beeac247732eb1797f367.woff2";